<template>
  <div id="header-auth" class="auth-state is-size-7">
    <template v-if="isAuthenticated">
      <span v-if="userName">
        Logged in as <b id="header-auth-fullname">{{ userName }}</b> <span class="mx-2">/</span>
      </span>
      <a href id="header-auth-logout" @click.prevent="logout">Log out</a>
    </template>
    <template v-else>
      <a href id="header-auth-login" @click.prevent="login">Log in</a>
    </template>
  </div>
</template>

<script>
import { msalInstance } from '@/auth/msalInstance';

export default {
  name: 'UserInfo',
  data() {
    return {
      isAuthenticated: false,
      userName: '',
    };
  },
  mounted() {
    const account = msalInstance.getActiveAccount();
    if (account) {
      this.isAuthenticated = true;
      this.userName = account.name || account.username;
    }
  },
  methods: {
    login() {
      msalInstance.loginRedirect();
    },
    logout() {
      msalInstance.logoutRedirect();
    }
  }
};
</script>